var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-assignee-picker" },
    [
      _vm.label
        ? _c(
            "span",
            { staticClass: "az-text-small text-color-600 mb-1 d-block" },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "offset-y": "",
            "min-width": "280",
            "max-width": "300",
            transition: "scale-transition",
            "content-class": "task-assignee-picker__menu"
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "button",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass:
                            "task-assignee-picker__trigger d-inline-flex align-center",
                          class: {
                            "task-assignee-picker__trigger--empty": !_vm.value
                              .length
                          },
                          attrs: {
                            type: "button",
                            disabled: _vm.disabled,
                            "aria-label": _vm.value.length
                              ? "Alterar responsável"
                              : "Adicionar responsável",
                            title: _vm.value.length ? null : _vm.placeholder
                          }
                        },
                        "button",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      !_vm.value.length
                        ? [
                            _c("icon-svg", {
                              attrs: {
                                name: "mdi-account-plus",
                                size: 16,
                                color: "var(--secondary)"
                              }
                            }),
                            !_vm.iconOnly
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "az-text-small text-color-400 ml-1"
                                  },
                                  [_vm._v(_vm._s(_vm.placeholder))]
                                )
                              : _vm._e()
                          ]
                        : [
                            _vm._l(_vm.decoratedVisibleValue, function(person) {
                              return _c(
                                "span",
                                {
                                  key: person.key,
                                  staticClass: "task-assignee-picker__avatar",
                                  style: {
                                    marginLeft: person.marginLeft,
                                    zIndex: person.zIndex,
                                    backgroundColor: person.bgColor,
                                    color: person.textColor
                                  },
                                  attrs: { title: person.nome }
                                },
                                [
                                  person.avatar
                                    ? _c("img", {
                                        staticClass:
                                          "task-assignee-picker__avatar-img",
                                        attrs: {
                                          src: person.avatar,
                                          alt: person.initials
                                        }
                                      })
                                    : _c("span", [
                                        _vm._v(_vm._s(person.initials))
                                      ])
                                ]
                              )
                            }),
                            _vm.overflowCount > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "task-assignee-picker__avatar task-assignee-picker__avatar--overflow",
                                    style: { marginLeft: "-6px" }
                                  },
                                  [
                                    _vm._v(
                                      " +" + _vm._s(_vm.overflowCount) + " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                    ],
                    2
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.menuOpen,
            callback: function($$v) {
              _vm.menuOpen = $$v
            },
            expression: "menuOpen"
          }
        },
        [
          _vm.menuOpen
            ? _c(
                "div",
                { staticClass: "task-assignee-picker__dropdown pa-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-2 py-1 az-text-small font-weight-bold text-color-500"
                    },
                    [_vm._v("Atribuir a")]
                  ),
                  _c(
                    "div",
                    { staticClass: "mb-2 px-1" },
                    [
                      _c("InputByType", {
                        staticClass: "new-ux",
                        attrs: {
                          type: "search",
                          label: "",
                          placeholder: "Buscar...",
                          outlined: "",
                          dense: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.loading
                    ? _c("v-progress-linear", {
                        staticClass: "mb-2",
                        attrs: { indeterminate: "", height: "2" }
                      })
                    : _vm._e(),
                  !_vm.loading && !_vm.hasResults
                    ? _c("div", { staticClass: "pa-3 text-center" }, [
                        _c(
                          "span",
                          { staticClass: "az-text-small text-color-400" },
                          [_vm._v("Nenhum resultado encontrado")]
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "task-assignee-picker__list",
                      on: { scroll: _vm.onListScroll }
                    },
                    [
                      _vm.filteredProfessionals.length > 0
                        ? _c(
                            "div",
                            { staticClass: "task-assignee-picker__section" },
                            [
                              _vm.filteredClients.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "px-2 pt-1 pb-1 az-text-small text-color-500"
                                    },
                                    [_vm._v(" Profissionais ")]
                                  )
                                : _vm._e(),
                              _vm._l(_vm.visibleProfessionals, function(prof) {
                                return _c(
                                  "div",
                                  {
                                    key: "prof-" + prof.id,
                                    staticClass:
                                      "task-assignee-picker__option d-flex align-center",
                                    class: {
                                      "task-assignee-picker__option--selected":
                                        _vm.selectedById[prof.id]
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.togglePerson(
                                          prof.raw,
                                          "profissional"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "task-assignee-picker__avatar mr-2",
                                        style: {
                                          backgroundColor: prof.bgColor,
                                          color: prof.textColor
                                        }
                                      },
                                      [
                                        prof.avatar
                                          ? _c("img", {
                                              staticClass:
                                                "task-assignee-picker__avatar-img",
                                              attrs: {
                                                src: prof.avatar,
                                                alt: prof.initials
                                              }
                                            })
                                          : _c("span", [
                                              _vm._v(_vm._s(prof.initials))
                                            ])
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "az-text-small flex-grow-1 text-color-800 text-truncate"
                                      },
                                      [_vm._v(" " + _vm._s(prof.nome) + " ")]
                                    ),
                                    prof.id === _vm.markResponsavel
                                      ? _c(
                                          "v-chip",
                                          {
                                            staticClass: "ml-1 mr-1",
                                            attrs: {
                                              "x-small": "",
                                              color: "primary",
                                              "text-color": "white"
                                            }
                                          },
                                          [_vm._v(" Responsável ")]
                                        )
                                      : _vm._e(),
                                    _vm.selectedById[prof.id]
                                      ? _c("icon-svg", {
                                          attrs: {
                                            name: "mdi-check",
                                            size: 16,
                                            color: "var(--primary)"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.filteredClients.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "task-assignee-picker__section",
                              class: {
                                "mt-1": _vm.filteredProfessionals.length > 0
                              }
                            },
                            [
                              _vm.filteredProfessionals.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "px-2 pt-1 pb-1 az-text-small text-color-500"
                                    },
                                    [_vm._v(" Clientes ")]
                                  )
                                : _vm._e(),
                              _vm._l(_vm.visibleClients, function(client) {
                                return _c(
                                  "div",
                                  {
                                    key: "client-" + client.id,
                                    staticClass:
                                      "task-assignee-picker__option d-flex align-center",
                                    class: {
                                      "task-assignee-picker__option--selected":
                                        _vm.selectedById[client.id]
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.togglePerson(
                                          client.raw,
                                          "cliente"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "task-assignee-picker__avatar mr-2",
                                        style: {
                                          backgroundColor: client.bgColor,
                                          color: client.textColor
                                        }
                                      },
                                      [
                                        client.avatar
                                          ? _c("img", {
                                              staticClass:
                                                "task-assignee-picker__avatar-img",
                                              attrs: {
                                                src: client.avatar,
                                                alt: client.initials
                                              }
                                            })
                                          : _c("span", [
                                              _vm._v(_vm._s(client.initials))
                                            ])
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "az-text-small flex-grow-1 text-color-800 text-truncate"
                                      },
                                      [_vm._v(" " + _vm._s(client.nome) + " ")]
                                    ),
                                    client.id === _vm.markResponsavel
                                      ? _c(
                                          "v-chip",
                                          {
                                            staticClass: "ml-1 mr-1",
                                            attrs: {
                                              "x-small": "",
                                              color: "primary",
                                              "text-color": "white"
                                            }
                                          },
                                          [_vm._v(" Responsável ")]
                                        )
                                      : _vm._e(),
                                    _vm.selectedById[client.id]
                                      ? _c("icon-svg", {
                                          attrs: {
                                            name: "mdi-check",
                                            size: 16,
                                            color: "var(--primary)"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }